import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'currency-tenge', 'CurrencyTenge', [["path",{"d":"M6 5h12"}],["path",{"d":"M6 9h12"}],["path",{"d":"M12 9v10"}]]);